/** Auto-generated by scripts/build-package.mjs — do not edit. */

import Renderer3DSystem from './system';

Object.assign(Renderer3DSystem, {
  packageName: "@combos-fun/plugin-renderer-3d",
  packageVersion: "0.0.39",
});
